import { createAsyncThunk } from '@reduxjs/toolkit';
import { getToken } from '../../Utils/authUtils';
import { REPORTS } from '../../constant';

interface Payload {
  studyInstanceUID: string;
  patientNameOverride: string;
  hospitalId: string;
}

export const updatePatientNameApi = createAsyncThunk(
  'updatePatientName',
  async (payload: Payload, { rejectWithValue }) => {
    try {
      const res = await fetch(REPORTS.UPDATE_PATIENT_NAME, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        const errorData = await res.json();
        return rejectWithValue(errorData.msg || 'Failed to update patient name');
      }
      return await res.json();
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : String(error));
    }
  }
);
